import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { IncomingInvoiceReminderList } from "@msuite/utils/types";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useIncomingInvoiceReminders() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Query */
	const query = useQuery({
		queryKey: ["incoming-invoices", "reminders"],
		enabled: citadel?.can("read", "IncomingInvoice") === true,
		queryFn: async () => {
			const response = await client.incoming_invoices.reminders.$get();
			const data = await responseHandler(response);
			return data.reminders as IncomingInvoiceReminderList;
		},
	});

	/** Return */
	return { ...query, reminders: query.data ?? [] };
}
